import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M13.353 2.622a.75.75 0 0 1 1.295.756l-1.78 3.05 8.063 13.822H22a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h1.07l8.062-13.822-1.78-3.05a.75.75 0 1 1 1.296-.756L12 4.94zm-4.926 17.63h7.146L12 14z" />
  </>
);

const CampingFilled = Icon('camping-filled', svgContents);

export default CampingFilled;
